import { createContainer } from 'react-sweet-state';

import { NotificationStore } from './NotificationStore';

export const NotificationStoreContainer = createContainer(NotificationStore, {
  onInit:
    () =>
    ({ setState }, { state }) => {
      if (state) {
        setState(state);
      }
    },
  onUpdate:
    () =>
    ({ setState }, { state }) => {
      if (state) {
        setState(state);
      }
    },
});
